import "./App.css";
import { React, useState } from "react";
import * as XLSX from "xlsx";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
function App() {
  const [greeting, setGreet] = useState("");
  const [subject, setSubject] = useState("");
  const [recipients, setRecipients] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log("Excel Data:", jsonData);
      setRecipients(jsonData);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    const payload = {
      greeting,
      subject,
      recipients,
      body,
    };

    try {
      // const response = await fetch("http://127.0.0.1:8000/api/sendBulkEmails/", {
      // const response = await fetch("http://127.0.0.1:8000/api/sendBulkEmails/", {
      const response = await fetch(
        "https://lead.python.hypertonic.co/api/sendBulkEmails/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "0dszq35F9oIzK18gwzF381TNcBmkDROM",
          },
          body: JSON.stringify(payload),
        },
      );

      let result;
      try {
        result = await response.json();
      } catch (jsonError) {
        // If response is not JSON
        console.error("JSON parse error:", jsonError);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (!response.ok) {
        const errorMessage =
          result.error || result.detail || `Server error: ${response.status}`;
        throw new Error(errorMessage);
      }

      console.log("API Response:", result);

      if (result.message) {
        setMessage(`✅ ${result.message}`);
      } else {
        setMessage("✅ Emails sent successfully!");
      }
      setMessageType("success");
      // handleReset(); // Optional: Don't reset immediately so user can see they sent it? Or keep it.
      // Keeping reset as requested previously, but maybe delay it?
      // User didn't request delay. Leaving handleReset() call creates a UX where form clears.
      // If form clears, they might lose what they sent.
      // Better to clear ONLY if completely successful?
      if (result.success_count === result.total_count) {
        handleReset();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage(`❌ Error: ${error.message}`);
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setGreet("");
    setSubject("");
    setRecipients("");
    setBody("");
  };

  return (
    <div className="container-fluid py-5">
      <form onSubmit={handleSubmit}>
        <fieldset disabled={loading}>
          <div id="myflotinp">
            <div className="form-header">
              <div className="text-center manin2">
                <img src="logo.png" alt="Logo" style={{ height: "50px" }} />
                <h3 className="k">Form For Bulk E-Mail</h3>
              </div>
            </div>

            <div className="form-content">
              {message && (
                <div
                  className={`alert ${messageType === "success" ? "alert-success" : "alert-danger"}`}
                >
                  {message}
                </div>
              )}

              <div className="row-2-cols">
                <div className="floating-group">
                  <input
                    type="text"
                    name="greeting"
                    id="greeting"
                    className="form-control"
                    value={greeting}
                    onChange={(e) => setGreet(e.target.value)}
                    placeholder=" "
                    required
                  />
                  <label htmlFor="greeting">Greeting Title</label>
                </div>

                <div className="floating-group">
                  <input
                    type="text"
                    name="subject"
                    id="subject"
                    className="form-control"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder=" "
                    required
                  />
                  <label htmlFor="subject">Subject for Mail</label>
                </div>
              </div>

              <div className="floating-group">
                <input
                  type="file"
                  name="file"
                  id="file"
                  className="form-control"
                  accept=".xlsx, .xls, .csv"
                  onChange={handleFileUpload}
                  placeholder=" "
                  required
                />
                <label htmlFor="file">Upload Excel File</label>
              </div>

              <div className="mb-3">
                <label className="form-label">Mail Body or Content:</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={body || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setBody(data);
                  }}
                  config={{
                    placeholder: "Write your message here...",
                    toolbar: [
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "link",
                      "bulletedList",
                      "numberedList",
                      "|",
                      "undo",
                      "redo",
                    ],
                  }}
                />
              </div>
            </div>

            <div className="form-footer">
              <div className="d-flex justify-content-between">
                <button
                  type="reset"
                  className="btn btn-dark w-50 me-2"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button type="submit" className="btn btn-primary w-50 ms-2">
                  {loading ? "Sending..." : "Submit"}
                </button>
              </div>

              {loading && (
                <div className="text-center mt-3">
                  <div
                    className="spinner-border text-primary"
                    role="status"
                  ></div>
                  <p className="mt-2">Sending E-mails...</p>
                </div>
              )}
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  );
}

export default App;
